
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../components/Navbar";
import EloscaCRMSidebar from "./layout/EloscaCRMSidebar";
import "./enquiry/styles/enquiryList.css";

export default function EloscaCRMLayout() {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <>
      <EloscaCRMSidebar onToggle={setSidebarExpanded} />

      <div
        style={{
          marginLeft: sidebarExpanded ? 260 : 64,
          transition: "margin-left 0.22s ease",
          minHeight: "100vh",
          backgroundColor: "#f8fafc",
        }}
      >
        <Navbar />

        <main
          className="container-fluid"
          style={{ padding: 24 }}
        >
          <Outlet />
        </main>
      </div>
    </>
  );
}
